import { Button } from '@components/button';
import { IconEmail } from '@components/icons/email';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { UnauthedPage } from 'components/unauthed-page';
import { useStore } from 'models/Provider';

export function Maintenance() {
  const { t } = useStore();

  return (
    <UnauthedPage>
      <Stack space={6} align="flex-start">
        <Text font="heading1" color="purple100" text={t('maintenance.header')} />
        <Stack space={4}>
          <Text font="regular16" color="purple80" text={t('maintenance.message')} />
          <Text font="regular16" color="purple80" text={t('maintenance.info')} />
          <Text font="regular16" color="purple80" text={t('maintenance.thanks')} />
        </Stack>
        <a href="mailto:help@50skills.com">
          <Button variant="secondary" text={t('maintenance.button')} iconLeft={<IconEmail />} />
        </a>
      </Stack>
    </UnauthedPage>
  );
}
